import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { portInfoFileTitleEncode } from '~pages/pages-behind-login/port-info-page/utils/form-utils'

export interface PostPortInfoFilePayload {
  portInfoId: string
  field: string
  file: File
  title?: string
}

export interface PostPortInfoFileResponse {
  ok: string
  id: string
}

export function usePostPortInfoFile() {
  const fetchRequest = useFetch<PostPortInfoFileResponse>()

  return useMutation({
    mutationFn: async ({
      portInfoId,
      field,
      file,
      title,
    }: PostPortInfoFilePayload) => {
      const formData = new FormData()
      formData.append('type', 'port-info')
      formData.append('portInfoId', portInfoId)
      formData.append('field', field)
      formData.append('file', file)
      if (title) {
        formData.append('title', portInfoFileTitleEncode(title))
      }

      const response = await fetchRequest(
        `${apiBase()}/files`,
        undefined,
        undefined,
        'POST',
        formData,
      )

      return response
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/portinfo', variables.portInfoId],
      })
    },
  })
}
